import { useEffect, useState } from 'react';

export type MODAL_STATE = 'hidden' | 'update_info' | 'updating' | 'defer_modal' | 'success' | 'error';

export type CourseUpdateInfo = {
  id: string;
  name: string;
  whatYouLearn: string;
  skills: string[];
};

export type S12nUpdateInfo = {
  id: string;
  name: string;
  type: string;
  url: string;
  nextActiveItemUrl: string;

  description: string;
  hoursAdded: number;

  coursesAdded: CourseUpdateInfo[];
  coursesRemoved: CourseUpdateInfo[];
};

const COURSE: CourseUpdateInfo = {
  id: '',
  name: 'Course Name',
  whatYouLearn: 'A lot of useful things!',
  skills: ['Skill 1', 'Skill 2'],
};

const UPDATE = {
  id: 's12n-1',
  name: 'Pharmacology for beginners',
  type: 'Specialization',
  description: 'TEXT FROM SPECIALIZATION VERSION DESCRIPTION.',
  hoursAdded: 36,

  url: '/programs/everything-for-everyone-ncza0/specializations/systems-biology',
  nextActiveItemUrl: '/learn/the-science-of-well-being/supplement/QThp6',

  coursesAdded: [
    {
      ...COURSE,
      id: 'course-1',
    },
    {
      ...COURSE,
      id: 'course-2',
    },
  ],
  coursesRemoved: [
    {
      ...COURSE,
      id: 'course-3',
    },
  ],
};

export default function useFetchS12nVersioningInfo() {
  const [modalState, setModalState] = useState<MODAL_STATE>('hidden');

  const [hasDeferred, setHasDeferred] = useState(false); // local storage? query?

  const s12nUpdateInfo: S12nUpdateInfo | null = UPDATE; // useQuery, etc etc

  useEffect(() => {
    if (s12nUpdateInfo) {
      const hasNewS12nVersion = true;

      if (hasNewS12nVersion && !hasDeferred) {
        setModalState('update_info');
      }
    }
  }, [s12nUpdateInfo, hasDeferred]);

  return {
    confirmDefer: () => {
      setModalState('defer_modal');
    },
    defer: () => {
      setHasDeferred(true);
    },
    dismiss: () => {
      setModalState('hidden');
    },
    update: (fail = false) => {
      setModalState('updating');
      setTimeout(() => {
        setModalState(fail ? 'success' : 'error');
      }, 2000);
    },
    modalState,
    s12nUpdateInfo,
  };
}
